import * as React from 'react';
import { Box, BoxStyle } from '../components/Box';
import Header from '../components/Header';
import GuideGraph from '../components/GuideGraph';
import { Guide } from '../guide';
import StepsList from './guide/StepsList';
import DoseSection from './guide/DoseSection';
import BasicInfo from './guide/BasicInfo';
import ShareSection from './guide/ShareSection';
import GuideActions from './guide/GuideActions';
import PublicFooter from '../components/PublicFooter';

export interface GuideProps {
  guide: Guide;
}

export default class GuidePage extends React.Component<GuideProps, any> {
  render() {
    const { guide } = this.props;

    return (
      <div className={BoxStyle.Padded}>
        <GuideGraph guide={guide} />
        <Header
          title={guide.name}
          subtitle={guide.description_text || guide.method}
        />
        <GuideActions guide={guide} />
        <ShareSection guide={guide} />
        <BasicInfo guide={guide} />
        <DoseSection guide={guide} />
        <StepsList guide={guide} />
        <PublicFooter />
      </div>
    );
  }
}
